import { API_CALL_STATUS } from '../../../reducers/status';
import axios from 'axios';
import { setBranchCodesApiStatus } from '../../../actions/kaMetlhaFuneralClaim/referenceData';
import { getUploadDocumentArray } from '../../../selectors/kaMetlhaFuneralClaim/uploadDocuments';
import { getClaimentDetailsForm } from '../../../selectors/kaMetlhaFuneralClaim/claimentDetails';
import { getDecesedId } from '../../../selectors/kaMetlhaFuneralClaim/deceasedDetails';
import { navigateToSuccessPage } from '../../../actions/kaMetlhaFuneralClaim/routing';

export const uploadDocumentMailService = (store, next, action) => {
    const state = store.getState();
    (async () => {
        try {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.PENDING,apiFor:'documentUpload'}));
            const documentsArray = getUploadDocumentArray(state);
            const {firstName,middleName,lastName,mobileNumber,email,policyNumber}= getClaimentDetailsForm(state);
            const productLabel = 'Ka-Metlha-Funeral-Claim';
            const referenceNumber = getDecesedId(state);
            const text = `Please find the ${firstName?.value+' '+lastName?.value}'s Document.`
            const subject = `Web: ${productLabel} : ${firstName?.value+' '+lastName?.value} - REF: ${referenceNumber?.value}`;
            const files = await documentsArray.reduce(async (f, x) => {
                return f.then(async (last) => {
                    let hasError = false;
                    if (x.file !== null) {
                        const formData = new FormData();
                        formData.append('files', x.file);
                        formData.append('subject', subject);
                        formData.append('contactNumber', null);
                        formData.append('email', "BW_KMF_BUSSINESS_MAIL");
                        formData.append('text',text)
                        const executeApiWithDelay = async () => {
                            return new Promise ((resolve)=>{
                                setTimeout(async () =>{                               
                                await uploadDocuments(formData)
                                    .then((response) => {
                                        if (response && response?.status === 200) {
                                            hasError = false;
                                        } else {
                                            hasError = true;
                                        }
                                    })
                                    .catch((error) => {
                                        throw error;
                                    })
                                return resolve()
                                }
                        ,500);
                            }
                            )
                        };
                        await executeApiWithDelay();
                    }

                    last.push({ key: x.fileName, hasError });

                    return last;
                });
            }, Promise.resolve([]));
            if (files.some((x) => x.hasError)) {
                store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'documentUpload'}));
            }
            store.dispatch(navigateToSuccessPage());
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.SUCCESS,apiFor:'documentUpload'}));
        } catch (e) {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'documentUpload'}));
        }
    })();
    return next(action);
};

const uploadDocuments = async (payload) => {
    const url = 'om-api/ka-metlha-funeral/documents/kyc';
    try {
        const response = await axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-api-key': 'test-api-key',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
